import { useState } from 'react';

import Input from '@/components/Inputs/Input';
import { useModalContext } from '@/components/Modal/Modal';
import Typo from '@/components/Typography/Typo';
import service from '@/services';
import { connectionErrorHandler } from '@/services/integrations/util';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { isEmptyString } from '@/utils/util';

import { CompoundConnectModal } from '../../components/ConnectModal';
import type { G2Info } from '../types';

type Props = {
  onConnectComplete: (workspace: G2Info) => void;
};

export const G2ConnectModal = (props: Props) => {
  const { closeModal } = useModalContext();
  const [token, setToken] = useState('');
  const [error, setError] = useState<string | null>(null);
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);

  const handleConnectWorkspace = async () => {
    if (!currWorkspace) return;
    try {
      const data = await service.g2.createG2Info(token, currWorkspace.alias);
      props.onConnectComplete(data);
      closeModal();
    } catch (e) {
      setError(connectionErrorHandler(e));
    }
  };

  const isTokenValid = !isEmptyString(token);

  return (
    <CompoundConnectModal
      title="Connect G2"
      description="Token is required to connect to G2."
      error={error}
      connectButtonDisabled={!isTokenValid}
      handleConnectWorkspace={handleConnectWorkspace}
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <Typo type="label2" weight="sb">
            Token
          </Typo>
          <Input
            placeholder="Enter the token of your G2 account"
            sizeType="m"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
        </div>
      </div>
    </CompoundConnectModal>
  );
};
